import { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { passportTabs } from '../../lib/playerPassport';

export const PassportTabs = ({ tab, onSelect }) => {
  const row = useRef(null);
  const [edges, setEdges] = useState({ left: false, right: false });
  const measure = useCallback(() => {
    const node = row.current;
    if (node) setEdges({ left: node.scrollLeft > 2, right: node.scrollLeft + node.clientWidth < node.scrollWidth - 2 });
  }, []);
  useEffect(() => {
    const node = row.current;
    const observer = new ResizeObserver(measure);
    observer.observe(node); measure();
    return () => observer.disconnect();
  }, [measure]);
  const reveal = node => {
    const container = row.current;
    const left = node.offsetLeft - container.offsetLeft;
    if (left < container.scrollLeft + 30) container.scrollTo({ left: Math.max(0, left - 30), behavior: 'smooth' });
    else if (left + node.offsetWidth > container.scrollLeft + container.clientWidth - 30) container.scrollTo({ left: left + node.offsetWidth - container.clientWidth + 30, behavior: 'smooth' });
  };
  useEffect(() => {
    const selected = row.current?.querySelector('[aria-selected="true"]');
    if (selected) reveal(selected);
  }, [tab]);
  const keyboard = event => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const buttons = [...row.current.querySelectorAll('[role="tab"]')];
    const index = buttons.indexOf(event.currentTarget);
    const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
    buttons[next].focus({ preventScroll: true }); buttons[next].click(); reveal(buttons[next]);
  };
  return <div className="passport-tab-dock" data-testid="pp-tab-dock">
    <button className="passport-tab-cue cue-left" type="button" disabled={!edges.left} aria-hidden={!edges.left} tabIndex={edges.left ? 0 : -1} data-testid="pp-tab-scroll-left" aria-label="Show earlier Passport tabs" onClick={() => row.current.scrollBy({ left: -200, behavior: 'smooth' })}><ChevronLeft size={19} /></button>
    <div ref={row} className="workspace-tabs pp-tabs" role="tablist" aria-label="Player Passport sections" data-testid="pp-tabs" onScroll={measure}>
      {passportTabs.map(name => { const value = name.toLowerCase(); return <button key={value} id={`pp-tab-${value}`} role="tab" aria-selected={tab === value} aria-controls={`pp-panel-${value}`} tabIndex={tab === value ? 0 : -1} data-testid={`pp-tab-${value}`} className={tab === value ? 'selected' : ''} onKeyDown={keyboard} onClick={() => onSelect(value)}>{name}</button>; })}
    </div>
    <button className="passport-tab-cue cue-right" type="button" disabled={!edges.right} aria-hidden={!edges.right} tabIndex={edges.right ? 0 : -1} data-testid="pp-tab-scroll-right" aria-label="Show more Passport tabs" onClick={() => row.current.scrollBy({ left: 200, behavior: 'smooth' })}><ChevronRight size={19} /></button>
  </div>;
};